var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"exercise-green",class:{
    'exercise-red': !_vm.log
  }},[_vm._v(" "+_vm._s(_vm.log ? 'Yes' : 'No')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }